(() => {
  class WholesaleQuickNote extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-quick-note-content]');
      this.button = this.querySelector('[data-quick-note-toggle]');
      if (!this.content || !this.button) return;
      this.expanded = this.dataset.startCollapsed !== 'true';
      this.animating = false;
      this.buttonHandler = () => this.animateTo(!this.expanded);
      this.resizeHandler = () => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.refreshHeight());
      };
      this.transitionHandler = event => {
        if (event.propertyName === 'height') this.finishAnimation();
      };
      this.button.addEventListener('click', this.buttonHandler);
      this.content.addEventListener('transitionend', this.transitionHandler);
      window.addEventListener('resize', this.resizeHandler, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.animating) this.resizeHandler();
        });
        const inner = this.content.firstElementChild;
        if (inner) this.resizeObserver.observe(inner);
      }
      this.renderState();
      this.content.style.height = this.expanded ? 'auto' : '0px';
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.buttonHandler);
      this.content?.removeEventListener('transitionend', this.transitionHandler);
      window.removeEventListener('resize', this.resizeHandler);
      cancelAnimationFrame(this.resizeFrame);
      clearTimeout(this.animationTimer);
      this.resizeObserver?.disconnect();
    }

    animateTo(expanded) {
      clearTimeout(this.animationTimer);
      const startHeight = this.content.getBoundingClientRect().height;
      const targetHeight = expanded ? this.content.scrollHeight : 0;
      this.content.style.height = `${startHeight}px`;
      this.content.getBoundingClientRect();
      this.expanded = expanded;
      this.animating = true;
      this.renderState();
      requestAnimationFrame(() => {
        this.content.style.height = `${targetHeight}px`;
      });
      this.animationTimer = setTimeout(() => this.finishAnimation(), 450);
    }

    finishAnimation() {
      if (!this.animating) return;
      clearTimeout(this.animationTimer);
      this.animating = false;
      this.content.style.height = this.expanded ? 'auto' : '0px';
    }

    refreshHeight() {
      if (this.animating) return;
      this.content.style.height = this.expanded ? 'auto' : '0px';
    }

    renderState() {
      this.classList.toggle('is-expanded', this.expanded);
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.querySelector('[data-quick-note-more]').hidden = this.expanded;
      this.querySelector('[data-quick-note-less]').hidden = !this.expanded;
      const arrow = this.querySelector('[data-quick-note-arrow]');
      if (arrow) arrow.textContent = this.expanded ? '↑' : '↓';
    }
  }

  if (!customElements.get('wholesale-quick-note')) customElements.define('wholesale-quick-note', WholesaleQuickNote);
})();
